export default {
  events: {
    left: null, // 'prevImg',
    right: null, // 'nextImg',
    esc: null, // 'closePreview',
    'command i': null, // toggle infopanel
    'command h': null, // toggle historypanel
  },
};
